<div class="flex desktop:flex-nowrap flex-wrap gap-4" [ngClass]="isAuthenticated ? 'mt-4 justify-between' : 'justify-center items-center h-[100dvh] background-container'">
  <nz-card [ngClass]="isAuthenticated ? 'desktop-lg:w-7/12 desktop:w-8/12' : 'desktop-lg:w-6/12 desktop:w-6/12'">
    @if(isAuthenticated){
    <nz-page-header class="p-0">
      <nz-page-header-title class="text-base">Raise a support ticket</nz-page-header-title>
      <nz-page-header-extra>
        <span class="flex items-center gap-x-2 text-xs mt-1">
          <span class="font-semibold">Support Phone number:</span>
          <a class="text-primary font-semibold" href="tel:+13022271222" *ngIf="feUtil.getRegion == 'us' || feUtil.getRegion == 'local' else supportNoTemp"> 
            +1 302-227-1222
          </a>
          <ng-template #supportNoTemp>
            <a class="text-primary font-semibold" href="tel:+919137524915"> +91 91375 24915</a>
          </ng-template>
          <nz-divider nzType="vertical"></nz-divider>
          <a routerLink="/training-videos" class="text-primary font-semibold">View Tutorials</a>
        </span>
      </nz-page-header-extra>
    </nz-page-header>
    } @else {
    <div class="text-primary text-xl sm:text-2xl font-semibold mb-4 sm:mb-6">
      <div class="flex flex-col justify-center items-center space-y-3">
        @if(feUtil.getRegion == 'us' || feUtil.getRegion == 'local') {
        <img nz-image src="assets/svg/hezkytech-ai.png" alt="Hezky tech" class="logo" draggable="false" width="100px"
          sm:width="100px">
        } @else {
        <img nz-image src="assets/svg/hezky_logo_V2.png" alt="Hezky tech" class="logo" draggable="false" width="80px"
          sm:width="100px">
        }
        <div class="flex items-center">
          <i nz-icon nzType="customer-service" class="text-primary mr-2"></i>
          <span>Raise a support ticket</span>
        </div>
      </div>
    </div>
    }
    @if(isAuthenticated){
    <nz-divider class="my-2"></nz-divider>
    } @else {
    <nz-divider class="my-2" nzDashed nzColor="primary" nzText="We're here to help you"></nz-divider>
    }
    <div
      class="flex desktop:items-start desktop:justify-center desktop:flex-row mini:flex-col mini:items-center mini:justify-center gap-4 p-3">
      <div class="w-full">
        <form [formGroup]="ticketForm" nz-form nzLayout="vertical" (ngSubmit)="onSubmitTicket()">
          <div nz-row [nzGutter]="[14,0]">
            <ng-container *ngIf="!isAuthenticated">
              <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item>
                  <nz-form-label nzRequired>Customer ID</nz-form-label>
                  <nz-form-control [nzErrorTip]="customerIdError">
                    <input nz-input OnlyNumber formControlName="customer_id" maxlength="5"
                      placeholder="Enter Customer ID" />
                  </nz-form-control>
                  <ng-template #customerIdError let-control>
                    @if (control.errors?.['required']) { Customer ID is Required! }
                  </ng-template>
                </nz-form-item>
              </div>
              <!-- <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="14" nzXl="16">
                <nz-form-item>
                  <nz-form-label nzRequired>Username</nz-form-label>
                  <nz-form-control [nzErrorTip]="usernameError">
                    <input nz-input formControlName="user_name" maxlength="50" placeholder="Enter First and Last Name" />
                  </nz-form-control>
                  <ng-template #usernameError let-control>
                    @if (control.errors?.['required']) { Username is Required! }
                  </ng-template>
                </nz-form-item>
              </div> -->
              <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item>
                  <nz-form-label nzRequired>Email</nz-form-label>
                  <nz-form-control [nzErrorTip]="emailError">
                    <input nz-input formControlName="email" maxlength="100" placeholder="Enter Email ID" />
                  </nz-form-control>
                  <ng-template #emailError let-control>
                    @if (control.errors?.['required']) { Email is Required! }
                    @if (control.errors?.['pattern']) { Please enter a valid email address. }
                  </ng-template>
                </nz-form-item>
              </div>
              <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                <nz-form-item>
                  <nz-form-label nzRequired>Subject</nz-form-label>
                  <nz-form-control [nzErrorTip]="subjectError">
                    <input nz-input formControlName="subject" maxlength="50" placeholder="Enter Subject" />
                  </nz-form-control>
                  <ng-template #subjectError let-control>
                    @if (control.errors?.['required']) { Subject is Required! }
                  </ng-template>
                </nz-form-item>
              </div>
            </ng-container>

            <ng-container *ngIf="isAuthenticated">
              <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item>
                  <nz-form-label nzRequired>Location</nz-form-label>
                  <nz-form-control>
                    <nz-tree-select [nzStatus]="value === null || isLocationError  ? 'error' : ''" class="w-full"
                      [nzDefaultExpandAll]="true" [nzAllowClear]="false" [nzMaxTagCount]="8"
                      [nzDropdownStyle]="{ maxHeight: '300px', overflow: 'auto'}" [nzHideUnMatched]="true"
                      [ngModelOptions]="{standalone: true}" [(ngModel)]="value" #tree [nzNodes]="nodes || []"
                      (ngModelChange)="onLocationChange($event)" nzShowSearch nzPlaceHolder="Please select location">
                    </nz-tree-select>
                    <ng-container *ngIf="value === null || isLocationError">
                      <span class="text-[#ff4d4f] mt-1">Location is Required!</span>
                    </ng-container>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item>
                  <nz-form-label nzRequired>Subject</nz-form-label>
                  <nz-form-control [nzErrorTip]="userSubjectError">
                    <input nz-input formControlName="user_subject" maxlength="50" placeholder="Enter Subject" />
                  </nz-form-control>
                  <ng-template #userSubjectError let-control>
                    @if (control.errors?.['required']) { Subject is Required! }
                  </ng-template>
                </nz-form-item>
              </div>
            </ng-container>

            <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
              <nz-form-item>
                <nz-form-label nzRequired>Description</nz-form-label>
                <nz-form-control [nzErrorTip]="descriptionError">
                  <nz-textarea-count [nzMaxCharacterCount]="500">
                    <textarea maxlength="500" rows="3" nz-input
                      formControlName="{{ isAuthenticated ? 'user_description' : 'description' }}"
                      placeholder="Enter ticket description" class="w-full"></textarea>
                  </nz-textarea-count>
                </nz-form-control>
                <ng-template #descriptionError let-control>
                  @if (control.errors?.['required']) { Description is Required! }
                </ng-template>
              </nz-form-item>
            </div>

            <ng-container *ngIf="isAuthenticated">
              <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                <label class="block text-sm font-medium text-gray-700 mb-2">Attachments</label>
                <div class="upload-container" [class.hidden]="fileList.length >= maxFiles">
                  <label for="attachmentFile" class="custom-file-upload">
                    <i nz-icon nzType="upload" nzTheme="outline" class="text-[30px] text-primary"></i>
                    <input #supportFile type="file" id="files" (change)="onFileChange($event)"
                      accept=".pdf,.jpeg,.jpg,.png,.mp4" multiple title="" />
                    <p class="ant-upload-text">Click or drag files to upload</p>
                    <p class="ant-upload-hint"> Support for single or bulk upload. Max 3 files, 5MB each. </p>
                  </label>
                </div>
                <div class="uploaded-files mt-3" *ngIf="fileList.length > 0">
                  <div *ngFor="let file of fileList; let i = index"
                    class="uploaded-file flex items-center justify-between mb-2 p-2 border border-gray-200 rounded">
                    <i nz-icon [nzType]="file.name.toLowerCase().endsWith('.pdf') ? 'file-pdf' : 'file-image'"
                      nzTheme="twotone" class="mr-2"></i>
                    <span class="filename flex-1 truncate">{{ file?.name }}</span>
                    <span class="filesize text-sm text-gray-600 mx-2">
                      ({{ (file.size / 1024 / 1024).toFixed(2) }} MB)
                    </span>
                    <button type="button" nzType="link" (click)="removeFile(i)" class="text-danger">
                      <i nz-icon nzType="delete"></i>
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="text-right mt-4">
            <button nz-button type="button" nzType="default" class="mr-4" (click)="resetForm()">Reset</button>
            <button nz-button type="submit" nzType="primary" [disabled]="!isFormValid" [nzLoading]="isLoading">Submit
              Ticket</button>
          </div>
        </form>
      </div>
    </div>
  </nz-card>
  <nz-card class="desktop-lg:w-5/12 desktop:w-4/12 w-full" *ngIf="isAuthenticated">
    <nz-page-header class="p-0">
      <nz-page-header-title class="text-base">Recent Tickets</nz-page-header-title>
    </nz-page-header>
    <nz-divider class="my-2"></nz-divider>
    <div class="w-full sm:w-6/6 py-2">
      <div class="flex justify-between">
        <nz-radio-group class="mb-3" nzButtonStyle="outline" [ngModel]="quickFilter" (ngModelChange)="quickFilterChange($event)">
          <label *ngFor="let filter of filters" nz-radio-button [nzValue]="filter.value" [class]="filter.class">
            <i *ngIf="filter.icon" nz-icon [nzType]="filter.icon" [nzTheme]="filter.theme || 'outline'" class="mr-1"></i>
            <span *ngIf="filter.customIcon" class="mr-2" style="font-size: 14px !important" nz-icon
              [nzType]="filter.customIcon"></span>
            {{filter.label}} {{filter.count}}
          </label>
        </nz-radio-group>
        <button nz-button nzType="default" nzShape="circle" (click)="getRecentTicket()">
          <i nz-icon nzType="reload" nzTheme="outline" nz-tooltip nzTooltipTitle="Refresh" nzTooltipPlacement="top" nzTooltipColor="#fff"></i>
        </button>
      </div>

      <nz-table #ticketTable [nzLoading]="isTableLoading" [nzShowPagination]="true" [nzFrontPagination]="true"
        [nzPageSize]="paginationConfig['pageSize']" [nzPageIndex]="paginationConfig['pageIndex']"
        [nzShowTotal]="totalTemplate" [nzShowSizeChanger]="true" [nzTotal]="ticketList.length" nzSize="small"
        [nzData]="ticketList" [nzScroll]="{y:'400px'}" class="w-full">
        <thead>
          <tr>
            <th nzWidth="90px">Ticket ID</th>
            <th nzWidth="100px">Subject</th>
            <th nzWidth="150px">Create At</th>
            <th nzWidth="80px">Status</th>
            <th nzWidth="100px">Location</th>
            <th nzWidth="90px">View Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ticket of ticketTable.data">
            <td>{{ ticket?.ticket_id }}</td>
            <td nzEllipsis>
              <span nz-tooltip nzTooltipTitle="{{ ticket?.subject }}" nzTooltipPlacement="top" nzTooltipColor="#fff">{{
                ticket?.subject }}</span>
            </td>
            <td>{{ ticket?.createDate | gDate: 'dd-MM-yyyy HH:mm' }}</td>
            <td>
              <nz-tag [nzColor]="getStatusColor(ticket?.status)">
                {{ ticket?.status }}
              </nz-tag>
            </td>
            <td>{{ ticket?.display_name }}</td>
            <td><button nz-button nzType="link" class="text-primary" (click)="viewTicket(ticket)">View</button>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </nz-card>
</div>

<ng-template #viewTicketModal>
  <span class="font-medium">Subject:</span>
  <p>{{ticketById.subject}}</p>
  <span class="font-medium">Description:</span>
  <p>
    {{ isExpanded ? ticketById.description : (ticketById.description | slice:0:100)}}
    <ng-container *ngIf="isExpanded"></ng-container>
    <a class="text-primary" *ngIf="ticketById.description.length > 100" (click)="toggleText()">
      {{ isExpanded ? 'Read Less' : '...Read More' }}
    </a>
  </p>
  <ng-container *ngFor="let file of parsedFileLocations; let i = index">
    <div class="flex items-center justify-start gap-x-1">
      <p *ngIf="parsedFileLocations.length > 1">{{ i + 1 }}.</p>
      <button nz-button nzType="link" class="text-primary px-0" (click)="openAttachment(file)">
        Download Attachment
        <i nz-icon nzType="download" nzTheme="outline"></i>
      </button>
    </div>
  </ng-container>
</ng-template>
<ng-template #totalTemplate let-total>Total {{ total }} items</ng-template>